import { t } from '@lingui/macro'
import { getProgressText } from 'front-end/src/pages/analytics/certifications/CertificationsOverviewTable'
import { AnalyticsSingleCertificationModelAsAdmin } from '../../../graphql/private/PrivateSchemaTypes'

export const prepareCertificationListExportCSV = (
  data: AnalyticsSingleCertificationModelAsAdmin[]
) =>
  data.map((row) => ({
    [t`Certification name`]: row.name,
    [t`Certification id`]: row.id,
    [t`Completed count`]: row.completed_count,
    [t`In progress count`]: row.in_progress_count,
    [t`Shared count`]: row.shared_count,
    [t`Progress`]: getProgressText(row.completed_count, row.shared_count)
  }))
